import TYPES from '@/modules/shared/types';

// Domain
import { GlobalTrackingRepository } from '../../domain/repositories/global-tracking-repository';
import { GlobalTrackingEntity } from '../../domain/entities/global-tracking-entity';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class GlobalTrackingHttpRepository implements GlobalTrackingRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private readonly endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/flagship/investor-goal/global-tracking/`;

  get(): Promise<GlobalTrackingEntity> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint)
        .then((response) => {
          response.json()
            .then(({ success, data, error }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(error));
              }
            });
        })
        .catch(reject);
    });
  }
}
